import { URL_API } from '../Configuracion/configuracion';
import Api from '../api';

export const getDistritos = () => {
    return Api.getInstance().executeGetQuery(`${URL_API}api/ed/distrito`)
        .then(res => res.data)
        .catch(err => console.log(err));
}

export const getRegiones = () => {
    return Api.getInstance().executeGetQuery(`${URL_API}api/ed/region`)
        .then(res => res.data)
        .catch(err => console.log(err));
}

export const getSucursales = () => {

    return Api.getInstance().executeGetQuery('api/ed/sucursal')
        .then((resp) => resp.data)
        .catch((error) =>
            console.log(error)
        );
}

export const getCarteraSucursal = (data) => {

    return Api.getInstance().executeQuery('/api/ed/cartera', data)
        .then((resp) => resp.data)
        .catch((error) =>
            console.log(error)
        );
}

